<template>
  <el-table :data="list" class="table-shin-expand">
    <el-table-column type="expand">
      <template scope="props">
        <div class="inner-list" v-for="row in NotSentProductLotLines(props.row.LotLines)" :key="row.Id">
          <div class="list-item">
            <label>批次号</label>
            <p class="no-margin">{{row.LotCode}}</p>
          </div>
          <div class="list-item" style="text-align: center;">
            <el-tag type="primary" style="margin-top: 8px">{{row.ConditionName}}</el-tag>
          </div>
          <div class="list-item">
            <label>租赁周期：</label>
            <p class="no-margin">{{row.RentalPeriod}}个月</p>
          </div>
          <div class="list-item">
            <label>折扣：</label>
            <p class="no-margin">{{row.DiscountRate * 100}}%</p>
          </div>
          <div class="list-item">
            <label>租赁单价：</label>
            <p class="no-margin">￥{{row.RentalUnitPrice}}</p>
          </div>
          <div class="list-item">
            <label>保修：</label>
            <p class="no-margin">￥{{row.WarrantyAmount}}/{{row.WarrantyMonths * 30}}天</p>
          </div>
          <div class="list-item">
            <label>租金：
              <el-tooltip popper-class="blue-tooltip" effect="dark" content="租赁单价*数量+保修费用" placement="top">
                <i class="el-icon-information"></i>
              </el-tooltip>
            </label>
            <p class="no-margin">￥{{row.RentalAmount}}</p>
          </div>
          <div class="list-item">
            <label>押金：</label>
            <p class="no-margin">￥{{row.Deposit}}</p>
          </div>
        </div>
        <p class="sent-lot-title" v-if="SentProductLotLines(props.row.LotLines).length">已发货批次</p>
        <div class="inner-list" v-for="row in SentProductLotLines(props.row.LotLines)" :key="row.Id">
          <div class="list-item">
            <label>批次号</label>
            <p class="no-margin">{{row.LotCode}}</p>
          </div>
          <div class="list-item" style="text-align: center;">
            <span class="el-tag el-tag--primary" style="margin-top: 8px">{{row.ConditionName}}</span>
          </div>
          <div class="list-item">
            <label>租赁周期：</label>
            <p class="no-margin">{{row.RentalPeriod}}个月</p>
          </div>
          <div class="list-item">
            <label>折扣：</label>
            <p class="no-margin">{{row.DiscountRate * 100}}%</p>
          </div>
          <div class="list-item">
            <label>租赁单价：</label>
            <p class="no-margin">￥{{row.RentalUnitPrice}}</p>
          </div>
          <div class="list-item">
            <label>保修：</label>
            <p class="no-margin">￥{{row.WarrantyAmount}}/{{row.WarrantyMonths * 30}}天</p>
          </div>
          <div class="list-item">
            <label>租金：
              <el-tooltip popper-class="blue-tooltip" effect="dark" content="租赁单价*数量+保修费用" placement="top">
                <i class="el-icon-information"></i>
              </el-tooltip>
            </label>
            <p class="no-margin">￥{{row.RentalAmount}}</p>
          </div>
          <div class="list-item">
            <label>押金：</label>
            <p class="no-margin">￥{{row.Deposit}}</p>
          </div>
          <div class="list-item">
            <el-button type="text">查看物流</el-button>
          </div>
        </div>
      </template>
    </el-table-column>
    <el-table-column label="物料名称" width="200px">
      <template scope="props">
        <p class="no-margin">{{props.row.ProductName}}</p>
        <p class="no-margin">物料编码：{{props.row.ProductCode}}</p>
      </template>
    </el-table-column>
    <el-table-column label="客户物料名称">
      <template scope="props">
        <p class="no-margin">{{props.row.CustomerProductName}}</p>
        <p class="no-margin" v-show="props.row.CustomerProductCode">物料编码：{{props.row.CustomerProductCode}}</p>
      </template>
    </el-table-column>
    <el-table-column label="品牌" prop="BrandName"></el-table-column>
    <el-table-column label="机型" prop="ModelName"></el-table-column>
    <el-table-column label="模块" prop="ModuleName"></el-table-column>
    <el-table-column label="租赁数量" prop="RentalQuantity"></el-table-column>
    <el-table-column label="保修期">
      <template scope="props">{{props.row.WarrantyMonths}}个月/{{props.row.WarrantyAmount}}元</template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  methods: {
    NotSentProductLotLines(sourceList) {
      let list = []
      if (sourceList) {
        list = sourceList.filter(item => item.State === 'notSent')
      }
      return list
    },
    SentProductLotLines(sourceList) {
      let list = []
      if (sourceList) {
        list = sourceList.filter(item => item.State !== 'notSent')
      }
      return list
    },
  },
}
</script>

<style lang="less" scoped>
.el-icon-information:hover {
  color: #20a0ff;
}
.sent-lot-title {
  color: #e88603;
  font-size: 13px;
  margin: 26px 0 0 58px;
  &:before {
    content: ' ';
    display: inline-block;
  }
}
.inner-list {
  margin: 0 30px;
  padding: 16px 28px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  border-bottom: 1px solid #e6eaee;
  &:last-child {
    border-bottom: none;
  }
  .list-item {
    margin-right: 20px;
    min-width: 100px;
    font-weight: bold;
    &:last-child {
      margin-right: 0;
    }
    label {
      font-size: 12px;
      color: #86939e;
      line-height: 1.5;
    }
    p {
      color: #364152;
    }
  }
}
</style>

<style lang="less">
.el-tooltip__popper.is-dark.blue-tooltip {
  background: #20a0ff;
  .popper__arrow, .popper__arrow::after {
    border-top-color: #20a0ff;
  }
}
</style>



// WEBPACK FOOTER //
// LeaseDetailTableNormal.vue?3daed4ec